<div
  #dateTrigger
  cdkOverlayOrigin
  #dateOrigin="cdkOverlayOrigin"
  class="tw-flex tw-h-[48px] tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-xl tw-bg-dt-surface-card tw-px-3 tw-shadow-elevation-control tw-border tw-border-transparent"
  [ngClass]="{
    '!tw-border-danger': isInvalid() && !isDisabled(),
    '!tw-cursor-not-allowed tw-opacity-50 !tw-shadow-elevation-input': isDisabled(),
  }"
  appKeyboardActivatable
  [appKeyboardActivatableDisabled]="isDisabled()"
  [appKeyboardActivatableExpanded]="open()"
  (appKeyboardActivatableActivate)="toggle()"
  (click)="toggle()"
>
  <span
    class="tw-form-field-text tw-tracking-[0.0125em]"
    [ngClass]="
      isDisabled()
        ? 'tw-text-dt-text-secondary'
        : !displayText()
          ? 'tw-text-dt-text-disabled'
          : 'tw-text-dt-text-headings'
    "
  >
    {{ displayText() || placeholder() }}
  </span>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="dateOrigin"
  [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayWidth]="overlayWidth() ?? dateTrigger.offsetWidth"
  [cdkConnectedOverlayMinWidth]="280"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayPush]="true"
  (overlayOutsideClick)="onOutsideClick($event, dateTrigger)"
>
  <app-calendar
    [singleDate]="true"
    [selectedDate]="selectedDate()"
    [currentDateFilter]="dateFilter()"
    (dateSelected)="onPicked($event)"
  ></app-calendar>
</ng-template>
